import { LitElement, css, html } from 'lit';
import { msg, localized } from '@lit/localize';
import { customElement, property } from 'lit/decorators.js';
import { globalStyles } from '../global-styles.js'

@localized()
@customElement('pp-certification')
export class PpCertification extends LitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: block;
        color: var(--pp-primary-text-color);
      }

      .secure-certification {
        overflow: hidden;
        margin-top: 1.5rem;
        padding-top: 1.5rem;
        border-top: 1px solid var(--pp-border-color);
      }

      .secure-certification.no-border {
        border-top: none;
      }

      h4 {
        margin-bottom: 0.5rem;
      }

      .logo-wrap {
        padding: 0 1rem;
      }

      .logo {
        width: 100%;
        height: 40px;
        margin-top: 8px;
        background-size: 100%;
        background-image: var(--pp-checkout-certification-bg, url('/images/certification.png'));
        background-repeat: no-repeat;
      }

      @media only screen and (min-width: 0) and (max-width: 576px){
        .secure-certification {
          margin-top: 0.75rem;
          margin-bottom: 0;
          padding: 0.75rem;
          padding-bottom: 0;
        }
      }
    `
  ];

  @property({ type: Boolean }) displayReturn = true;
  
  render() {
    return html`
      <div class="secure-certification m-b-1 align-center ${this.displayReturn? '': 'no-border'}">
        <h4 class="font-bold text-xs">${msg('SECURE CERTIFICATION')}</h4>
        <p class="text-xs">${msg('Our payment system is PCI-DSS Level 1 compliant. So your payment info stays safe at all times.')}</p>
        <div class="logo-wrap"><div class="logo"></div></div>
      </div>
    `;
  }
}
